import './cart.css';
import { CartIcon } from "../../assets/icons/CartIcon";
import { CloseIcon } from "../../assets/icons/CloseIcon";
import { useCart } from "../../context/CartContext";
import { CartTotal } from '../CartTotal/CartTotal';
import { CartItem } from '../CartItem/CartItem';
import { CouponInput } from '../CouponInput/CouponInput';
import { UtensilsInput } from '../UtensilsInput/UtensilsInput';

export const Cart = () => {
    //HOOKS
    const { cart, cartOpen, setCartOpen } = useCart();

    //FUNCTIONS

    return (
        <>
            <div className={cartOpen ? 'cart_modal_container active' : 'cart_modal_container'}>
                <div className='cart_container'>
                    <button className='close' onClick={() => setCartOpen(false)}>
                        <CloseIcon />
                    </button>
                    <div className='header'>
                        <CartIcon />
                        <h2>
                            Your order
                        </h2>
                    </div>
                    <div className='items_container'>
                        {cart && cart.items.map ((item) => {
                            return <CartItem item={item} key={'cart_item_' + item.id} />
                        })}
                    </div>
                    <hr/>
                    <CouponInput />
                    <UtensilsInput />
                    <CartTotal />
                </div>
            </div>
        </>
    );
}